<div class="reset-page">
    <div class="reset-card">
        <button type="button" class="back-link" (click)="onSignOut()">
            ← Sign out
        </button>

        <div class="icon-badge">
            <div class="icon-mask" [style.--icon-url]="'url(assets/icons/lock.svg)'"></div>
        </div>
        <h1>Create your password</h1>
        <p class="subtitle">For security, please replace the temporary password sent to your email.</p>

        <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="form-block">
            <div class="field-group">
                <label class="field-label" for="password">Password</label>
                <div class="input-wrapper" [class.input-wrapper--error]="passwordControl.invalid &&  submitted()">
                    <span class="input-icon">
                        <div class="password-icon-mask"
                            style="background-color: var(--text-muted); width: 14px; height: 16px;"
                            [style.--icon-url]="'url(assets/icons/password.svg)'"></div>
                    </span>
                    <input id="password" class="input-field" [type]="showPassword() ? 'text' : 'password'"
                        placeholder="Enter password" autocomplete="new-password" formControlName="password" />
                    <button type="button" class="toggle-password" (click)="togglePassword()"
                        [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'">
                        @if (showPassword()) {
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                            <path
                                d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                            <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                            <line x1="1" y1="1" x2="23" y2="23" />
                        </svg>
                        } @else {
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                            <circle cx="12" cy="12" r="3" />
                        </svg>
                        }
                    </button>
                </div>
                @if (passwordControl.invalid && passwordControl.touched) {
                <span class="field-error">Please enter a valid password.</span>
                }
            </div>

            <div class="strength-row" [ngClass]="{
                    weak: passwordStrength.label === 'WEAK',
                    medium: passwordStrength.label === 'MEDIUM',
                    strong: passwordStrength.label === 'STRONG'
                }">
                <div class="bars">
                    <span [class.filled]="passwordStrength.score >= 1"></span>
                    <span [class.filled]="passwordStrength.score >= 2"></span>
                    <span [class.filled]="passwordStrength.score >= 3"></span>
                    <span [class.filled]="passwordStrength.score >= 4"></span>
                </div>
                <strong class="strength-label">{{ passwordStrength.label }}</strong>
            </div>

            <ul class="rules">
                <li [class.done]="passwordChecks.minLength">At least 8 characters</li>
                <li [class.done]="passwordChecks.mixedCase">Uppercase + lowercase letters</li>
                <li [class.done]="passwordChecks.number">One number</li>
                <li [class.done]="passwordChecks.specialChar">
                    At least 1 special character (!@#$)
                </li>
            </ul>

            <div class="field-group">
                <label class="field-label" for="confirmPassword">Confirm password</label>
                <div class="input-wrapper" [class.input-wrapper--error]="(confirmPasswordControl.invalid || passwordForm.hasError('passwordMismatch')) && submitted()">
                    <span class="input-icon">
                        <div class="password-icon-mask" [style.--icon-url]="'url(assets/icons/password.svg)'"></div>
                    </span>
                    <input id="confirmPassword" class="input-field"
                        [type]="showConfirmPassword() ? 'text' : 'password'" placeholder="Confirm password"
                        autocomplete="new-password" formControlName="confirmPassword" />
                    <button type="button" class="toggle-password" (click)="toggleConfirmPassword()"
                        [attr.aria-label]="showConfirmPassword() ? 'Hide password' : 'Show password'">
                        @if (showConfirmPassword()) {
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                            <path
                                d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                            <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                            <line x1="1" y1="1" x2="23" y2="23" />
                        </svg>
                        } @else {
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                            <circle cx="12" cy="12" r="3" />
                        </svg>
                        }
                    </button>
                </div>
                @if (confirmPasswordControl.invalid && confirmPasswordControl.touched) {
                <span class="field-error">Please enter a valid password.</span>
                }

                @if (passwordForm.hasError('passwordMismatch') && confirmPasswordControl.touched) {
                <span class="field-error">Passwords do not match.</span>
                }
            </div>

            @if (errorMessage()) {
            <p class="error">{{ errorMessage() }}</p>
            }

            <button class="primary-btn muted" type="submit" [disabled]="!canSubmitPassword || isSubmitting()">
                {{ isSubmitting() ? 'Saving...' : 'Set password' }}
            </button>
        </form>
    </div>
</div>
